import './styles.scoped.css'
import {Typography, TextField} from '@mui/material'

export default ({form}) => {
    return (
        <>
            <Typography variant="overline" color="text.secondary">
                ADDITIONAL INFO
            </Typography>
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Internal Note
            </Typography>
            <TextField placeholder="Enter your internal note" multiline rows={11} fullWidth {...form.register('internalNote')} />
        </>
    )
}
